import { CoreMenu } from '@core/types';

// Get module access
function getModuleAccess(): string[] {
  let moduleAccess: string[] = [];

  try {
    const rawSub = localStorage.getItem('activeSubscription');
    const parsedSub = rawSub ? JSON.parse(rawSub) : null;
    const rawAccess = parsedSub?.plan?.module_access;

    if (rawAccess) {
      moduleAccess = rawAccess.split(',').map((m: string) => m.trim());
    } else {
      const rawFallback = localStorage.getItem('activePlanAccessSubscription');
      const parsedFallback = rawFallback ? JSON.parse(rawFallback) : null;
      const fallbackAccess = parsedFallback?.module_access || '';
      moduleAccess = fallbackAccess.split(',').map((m: string) => m.trim());
    }
  } catch (e) {
    console.error('Failed to parse subscription data from localStorage', e);
  }

  return moduleAccess;
}

// Get permissions
function getPermissions(): string[] | null {
  try {
    const permissionData = localStorage.getItem('permissions');
    if (!permissionData) return null;
    const parsedPermissions = JSON.parse(permissionData);
    return Array.isArray(parsedPermissions) ? parsedPermissions : [];
  } catch (e) {
    console.error('Failed to parse permission data:', e);
    return [];
  }
}

// Map menu IDs to subscription keys
const moduleAccessMap: Record<string, string> = {
  supplier: 'suppliers',
  role_permission: 'role_permission',
  dashboard: 'dashboard',
  expense: 'expense',
  customer: 'customer',
  order: 'order',
  income: 'income',
  forecast: 'forecast',
  team: 'team',
  division: 'division'
};

// Map menu IDs to permission prefixes
const permissionMap: Record<string, string> = {
  supplier: 'supplier',
  role_permission: 'role-permission',
  dashboard: 'dashboard',
  expense: 'expense',
  customer: 'customer',
  order: 'order',
  income: 'income',
  forecast: 'forecast',
  team: 'team',
  division: 'division'
};

// Full menu
const fullMenu: CoreMenu[] = [
  {
    id: 'dashboard',
    title: 'Dashboard',
    translate: 'Dashboard',
    type: 'item',
    icon: 'home',
    url: 'apps/dashboard'
  },
  {
    id: 'supplier',
    title: 'Suppliers',
    translate: 'Suppliers',
    type: 'item',
    icon: 'truck',
    url: 'apps/supplier'
  },
  {
    id: 'expense',
    title: 'Expenses',
    translate: 'Expenses',
    type: 'item',
    icon: 'credit-card',
    url: 'apps/expense',
  },
  {
    id: 'customer',
    title: 'Customers',
    translate: 'Customers',
    type: 'item',
    icon: 'user-check',
    url: 'apps/customer',
  },
  {
    id: 'order',
    title: 'Orders',
    translate: 'Orders',
    type: 'item',
    icon: 'shopping-cart',
    url: 'apps/order',
  },
  {
    id: 'income',
    title: 'Income',
    translate: 'Income',
    type: 'item',
    icon: 'dollar-sign',
    url: 'apps/income',
  },
  {
    id: 'forecast',
    title: 'Forecast',
    translate: 'Forecast',
    type: 'item',
    icon: 'bar-chart-2',
    url: 'apps/expense-forecast',
  },
  {
    id: 'team',
    title: 'Teams',
    translate: 'Teams',
    type: 'item',
    icon: 'users',
    url: 'apps/team'
  },
  {
    id: 'subscription',
    title: 'Subscription',
    translate: 'Subscription',
    type: 'item',
     icon: 'repeat',
    url: 'apps/subscription'
  },
  {
    id: 'role_permission',
    title: 'Role & Permission',
    translate: 'Role & Permission',
    type: 'item',
    icon: 'shield',
    url: 'apps/roleandpermission'
  }
];

// Get access + permissions
const moduleAccess = getModuleAccess();
const permissions = getPermissions();

// Filter menu
const filteredMenu = fullMenu.filter(item => {
  // Always include subscription
  if (item.id === 'subscription') return true;

  const accessKey = moduleAccessMap[item.id] || item.id;
  const hasModuleAccess = moduleAccess.includes(accessKey);


  if (!hasModuleAccess) return false;

  // If no permissions data in localStorage -> allow as usual
  if (!permissions || permissions.length === 0) return true;

  const permissionPrefix = permissionMap[item.id] || item.id;
  const hasViewPermission = permissions.some(
    p => p === `${permissionPrefix}-view-own` || p === `${permissionPrefix}-view-global`
  );

  return hasViewPermission;
});

// Export menu
export const menu: CoreMenu[] = filteredMenu;
